import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ParkPage from "@/pages/ParkPage";
import CaravanPage from "@/pages/CaravanPage";
import CaravansListPage from "@/pages/CaravansListPage";
import BookingFlow from "@/pages/BookingFlow";
import LoginPage from "@/pages/LoginPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminDashboard from "@/pages/AdminDashboard";
import ManagerDashboard from "@/pages/ManagerDashboard";
import CleanerDashboard from "@/pages/CleanerDashboard";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function MinimalLayout({ children }) {
  return <>{children}</>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          {/* Public pages with Navbar + Footer */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/parks/:slug" element={<PublicLayout><ParkPage /></PublicLayout>} />
          <Route path="/caravans" element={<PublicLayout><CaravansListPage /></PublicLayout>} />
          <Route path="/caravans/:slug" element={<PublicLayout><CaravanPage /></PublicLayout>} />

          {/* Booking flow - minimal layout */}
          <Route path="/book/:slug" element={<MinimalLayout><BookingFlow /></MinimalLayout>} />
          <Route path="/payment-success" element={<MinimalLayout><PaymentSuccess /></MinimalLayout>} />

          {/* Auth */}
          <Route path="/login" element={<MinimalLayout><LoginPage /></MinimalLayout>} />

          {/* Dashboards - own layout */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="/manager" element={<ManagerDashboard />} />
          <Route path="/manager/*" element={<ManagerDashboard />} />
          <Route path="/cleaner" element={<CleanerDashboard />} />
          <Route path="/cleaner/*" element={<CleanerDashboard />} />

          {/* SEO routes - serve homepage */}
          <Route path="/new-forest-caravan-holidays" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/hoburne-park-caravan-hire" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/hoburne-bashley-caravan-hire" element={<Navigate to="/parks/hoburne-bashley-caravan-hire" replace />} />
          <Route path="/hoburne-naish-caravan-hire" element={<Navigate to="/parks/hoburne-naish-caravan-hire" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
